import ProjectBrowseListModule from './project-browse-list.module'

export default ProjectBrowseListModule
